















import { Component, Vue } from 'vue-property-decorator'
import { FileResp } from '@@/components/upload/GlpUpload.vue'

/**
 * @title  限制
 * @desc 限制上传文件个数， 大小， 格式的限制。
 */
@Component
export default class LimitExample extends Vue {
  type = 'card'

  disabled = false

  value: FileResp[] = [
    {
      name: '1.jpg',
      url: 'http://localhost:3000/nas/download/1.jpg'
    }
  ]

  resp = (response: any) => response.data
}
